// extracted by mini-css-extract-plugin
module.exports = {"search_form":"search_user_form_search_form__1IL76","search_icon":"search_user_form_search_icon__17_lX","search_input":"search_user_form_search_input__2mSc_"};